document.addEventListener('DOMContentLoaded', function() {
  // Event delegation for filter clicks
  document.addEventListener('click', function(e) {
    const filterItem = e.target.closest('.jahome-bestsellers-filters > li');
    
    if (filterItem) {
      const targetCollection = filterItem.dataset.targetCollection;

      // Remove active class from all filter items and product lists
      const allFilterItems = document.querySelectorAll('.jahome-bestsellers-filters > li');
      const allProductLists = document.querySelectorAll('.jahome-bestsellers-product-list');
      
      allFilterItems.forEach(item => item.classList.remove('active'));
      allProductLists.forEach(list => list.classList.remove('active'));

      // Add active class to clicked filter item
      filterItem.classList.add('active');
      
      // Add active class to corresponding product list
      const targetProductList = document.querySelector(`.jahome-bestsellers-product-list[data-collection="${targetCollection}"]`);
      if (targetProductList) {
        targetProductList.classList.add('active');
      }
    }
  });
});